var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_blok block"},[_c('div',[_vm._v("Informační zpráva")]),_c('hr'),_vm._l((_vm.$store.state.listMsg),function(msg,index){return _c('InfoBlockMsg',{key:index,attrs:{"msg":msg.msg,"msg-type":msg.msgType}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }